import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const RegionGrid = ({ regions, title, description }) => {
    const { t } = useTranslation('common');

    if (!regions?.length) return null;

    return (
        <div className="mx-auto max-w-2xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
            {(title || description) && (
                <div className="max-w-3xl">
                    {title && (
                        <h2 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                            {title}
                        </h2>
                    )}
                    {description && (
                        <p className="mt-4 text-gray-500">
                            {description}
                        </p>
                    )}
                </div>
            )}

            <div className="mt-16 -mx-4 sm:-mx-6 lg:mx-0">
                <div className="overflow-x-auto px-4 sm:px-6 lg:px-0 lg:overflow-visible">
                    <ul
                        role="list"
                        className="inline-flex space-x-8 lg:grid lg:grid-cols-3 lg:gap-x-8 lg:space-x-0"
                    >
                        {regions.map((region) => (
                            <li key={`region-grid-${region.id}`}
                                className="inline-flex w-64 flex-shrink-0 flex-col lg:w-auto mb-10">
                                <Link to={`/region/${region.id}`} className="group relative">
                                    <div
                                        className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded bg-gray-200">
                                        <img
                                            alt={region.description || region.name}
                                            src={region.image1}
                                            className="h-full w-full object-cover object-center group-hover:opacity-75"
                                        />
                                    </div>
                                    <div className="relative mt-3">
                                        <h3 className="text-lg font-bold text-gray-900 truncate">
                                            {region.name}
                                            <span className="ml-2" aria-hidden="true">→</span>
                                        </h3>
                                    </div>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default RegionGrid;